import { render, staticRenderFns } from "./questionsList.vue?vue&type=template&id=92f42a72&scoped=true&"
import script from "./questionsList.vue?vue&type=script&lang=js&"
export * from "./questionsList.vue?vue&type=script&lang=js&"
import style0 from "./questionsList.vue?vue&type=style&index=0&id=92f42a72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f42a72",
  null
  
)

export default component.exports